import React from "react";
import StaffProfilInfo from "./StaffProfilInfo";
import StaffProfileDisciplinary from "./StaffProfileDisciplinary";

/**
 * Combined employee-record view for promotions / salary increments
 * and disciplinary actions (warning letters).
 */
export default function StaffProfileEmploymentActions({ staffBranchId }) {
  return (
    <div className="row g-3 mt-2">
      <div className="col-12">
        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white py-3">
            <h5 className="mb-0">
              <i className="bi bi-graph-up-arrow me-2"></i>
              Promotions &amp; Salary Changes
            </h5>
            <small className="text-muted">
              Promotion history and salary increments for this staff member
            </small>
          </div>
          <div className="card-body">
            <StaffProfilInfo />
          </div>
        </div>
      </div>

      <div className="col-12">
        <StaffProfileDisciplinary staffBranchId={staffBranchId} />
      </div>
    </div>
  );
}
